
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire581c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire581c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Do5B", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $58eedc976c0db041$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "isValidElement", function () { return $58eedc976c0db041$export$a8257692ac88316c; });
$parcel$export(module.exports, "createElement", function () { return $58eedc976c0db041$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $58eedc976c0db041$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $58eedc976c0db041$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $58eedc976c0db041$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $58eedc976c0db041$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $58eedc976c0db041$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $58eedc976c0db041$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $58eedc976c0db041$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $58eedc976c0db041$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "h", function () { return $58eedc976c0db041$export$c8a8987d4410bf2d; });
var $58eedc976c0db041$var$n, $58eedc976c0db041$export$41c562ebe57d11e2, $58eedc976c0db041$var$u, $58eedc976c0db041$export$a8257692ac88316c, $58eedc976c0db041$var$i, $58eedc976c0db041$var$r, $58eedc976c0db041$var$o, $58eedc976c0db041$var$e, $58eedc976c0db041$var$f, $58eedc976c0db041$var$c, $58eedc976c0db041$var$s, $58eedc976c0db041$var$a, $58eedc976c0db041$var$h, $58eedc976c0db041$var$p = {}, $58eedc976c0db041$var$v = [], $58eedc976c0db041$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $58eedc976c0db041$var$w = Array.isArray;
function $58eedc976c0db041$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $58eedc976c0db041$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $58eedc976c0db041$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $58eedc976c0db041$var$m(l, e, i, r, null);
}
function $58eedc976c0db041$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$58eedc976c0db041$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(e), e;
}
function $58eedc976c0db041$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $58eedc976c0db041$export$ffb0004e005737fa(n) {
    return n.children;
}
function $58eedc976c0db041$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $58eedc976c0db041$var$S(n, l) {
    if (null == l) return n.__ ? $58eedc976c0db041$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $58eedc976c0db041$var$S(n) : null;
}
function $58eedc976c0db041$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $58eedc976c0db041$var$C(n);
    }
}
function $58eedc976c0db041$var$M(n) {
    (!n.__d && (n.__d = !0) && $58eedc976c0db041$var$i.push(n) && !$58eedc976c0db041$var$$.__r++ || $58eedc976c0db041$var$r != $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) && (($58eedc976c0db041$var$r = $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) || $58eedc976c0db041$var$o)($58eedc976c0db041$var$$);
}
function $58eedc976c0db041$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $58eedc976c0db041$var$i.length;)$58eedc976c0db041$var$i.length > s && $58eedc976c0db041$var$i.sort($58eedc976c0db041$var$e), n = $58eedc976c0db041$var$i.shift(), s = $58eedc976c0db041$var$i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $58eedc976c0db041$var$d({}, r)).__v = r.__v + 1, $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(t), $58eedc976c0db041$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $58eedc976c0db041$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $58eedc976c0db041$var$N(f, t, c), r.__e = r.__ = null, t.__e != o && $58eedc976c0db041$var$C(t)));
    $58eedc976c0db041$var$$.__r = 0;
}
function $58eedc976c0db041$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || $58eedc976c0db041$var$v, b = l.length;
    for(f = $58eedc976c0db041$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $58eedc976c0db041$var$p : m[y.__i] || $58eedc976c0db041$var$p, y.__i = a, g = $58eedc976c0db041$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $58eedc976c0db041$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $58eedc976c0db041$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $58eedc976c0db041$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $58eedc976c0db041$var$m(null, o, null, null, null) : $58eedc976c0db041$var$w(o) ? $58eedc976c0db041$var$m($58eedc976c0db041$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $58eedc976c0db041$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $58eedc976c0db041$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $58eedc976c0db041$var$S(e)), $58eedc976c0db041$var$D(e, e));
    return t;
}
function $58eedc976c0db041$var$A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $58eedc976c0db041$var$A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $58eedc976c0db041$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $58eedc976c0db041$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($58eedc976c0db041$var$w(n) ? n.some(function(n) {
        $58eedc976c0db041$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $58eedc976c0db041$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $58eedc976c0db041$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $58eedc976c0db041$var$y.test(l) ? u : u + "px";
}
function $58eedc976c0db041$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $58eedc976c0db041$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $58eedc976c0db041$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($58eedc976c0db041$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $58eedc976c0db041$var$c, n.addEventListener(l, r ? $58eedc976c0db041$var$a : $58eedc976c0db041$var$s, r)) : n.removeEventListener(l, r ? $58eedc976c0db041$var$a : $58eedc976c0db041$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $58eedc976c0db041$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $58eedc976c0db041$var$c++;
            else if (u.t < t.u) return;
            return t($58eedc976c0db041$export$41c562ebe57d11e2.event ? $58eedc976c0db041$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $58eedc976c0db041$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $58eedc976c0db041$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $58eedc976c0db041$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $58eedc976c0db041$var$E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $58eedc976c0db041$var$d({}, h.__s)), $58eedc976c0db041$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $58eedc976c0db041$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $58eedc976c0db041$var$d($58eedc976c0db041$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $58eedc976c0db041$export$ffb0004e005737fa && null == a.key && (L = $58eedc976c0db041$var$V(a.props.children)), f = $58eedc976c0db041$var$I(n, $58eedc976c0db041$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$58eedc976c0db041$var$g(o[T]);
                $58eedc976c0db041$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $58eedc976c0db041$var$z(u);
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $58eedc976c0db041$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $58eedc976c0db041$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $58eedc976c0db041$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($58eedc976c0db041$var$z);
}
function $58eedc976c0db041$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$58eedc976c0db041$var$B(t[i], t[++i], t[++i]);
    $58eedc976c0db041$export$41c562ebe57d11e2.__c && $58eedc976c0db041$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $58eedc976c0db041$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $58eedc976c0db041$var$w(n) ? n.map($58eedc976c0db041$var$V) : $58eedc976c0db041$var$d({}, n);
}
function $58eedc976c0db041$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($58eedc976c0db041$export$41c562ebe57d11e2.__m && $58eedc976c0db041$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $58eedc976c0db041$var$n.call(u.childNodes), b = i.props || $58eedc976c0db041$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $58eedc976c0db041$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $58eedc976c0db041$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $58eedc976c0db041$var$I("template" == t.type ? u.content : u, $58eedc976c0db041$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $58eedc976c0db041$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$58eedc976c0db041$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $58eedc976c0db041$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $58eedc976c0db041$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $58eedc976c0db041$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $58eedc976c0db041$var$D(n, u, t) {
    var i, r;
    if ($58eedc976c0db041$export$41c562ebe57d11e2.unmount && $58eedc976c0db041$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $58eedc976c0db041$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $58eedc976c0db041$var$D(i[r], u, t || "function" != typeof n.type);
    t || $58eedc976c0db041$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $58eedc976c0db041$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $58eedc976c0db041$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $58eedc976c0db041$export$41c562ebe57d11e2.__ && $58eedc976c0db041$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $58eedc976c0db041$var$O(t, u = (!r && i || t).__k = $58eedc976c0db041$export$c8a8987d4410bf2d($58eedc976c0db041$export$ffb0004e005737fa, null, [
        u
    ]), o || $58eedc976c0db041$var$p, $58eedc976c0db041$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $58eedc976c0db041$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $58eedc976c0db041$var$N(e, u, f);
}
function $58eedc976c0db041$export$fa8d919ba61d84db(n, l) {
    $58eedc976c0db041$export$b3890eb0ae9dca99(n, l, $58eedc976c0db041$export$fa8d919ba61d84db);
}
function $58eedc976c0db041$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $58eedc976c0db041$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : t), $58eedc976c0db041$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $58eedc976c0db041$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $58eedc976c0db041$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $58eedc976c0db041$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$58eedc976c0db041$var$n = $58eedc976c0db041$var$v.slice, $58eedc976c0db041$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $58eedc976c0db041$var$u = 0, $58eedc976c0db041$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $58eedc976c0db041$var$d({}, this.state), "function" == typeof n && (n = n($58eedc976c0db041$var$d({}, u), this.props)), n && $58eedc976c0db041$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $58eedc976c0db041$var$M(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $58eedc976c0db041$var$M(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.render = $58eedc976c0db041$export$ffb0004e005737fa, $58eedc976c0db041$var$i = [], $58eedc976c0db041$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $58eedc976c0db041$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $58eedc976c0db041$var$$.__r = 0, $58eedc976c0db041$var$f = /(PointerCapture)$|Capture$/i, $58eedc976c0db041$var$c = 0, $58eedc976c0db041$var$s = $58eedc976c0db041$var$F(!1), $58eedc976c0db041$var$a = $58eedc976c0db041$var$F(!0), $58eedc976c0db041$var$h = 0;

});

parcelRegister("cflzh", function(module, exports) {

$parcel$export(module.exports, "route", function () { return $8ea79db61ca199dd$export$4cb887bfde2d34ca; });
$parcel$export(module.exports, "Link", function () { return $8ea79db61ca199dd$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "default", function () { return $8ea79db61ca199dd$export$55185c17a0fcbe46; });

var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
var $8ea79db61ca199dd$var$a = {};
function $8ea79db61ca199dd$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $8ea79db61ca199dd$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), c = 0; c < f.length; c++){
        var s = f[c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $8ea79db61ca199dd$var$d(n.replace(o, "")), t = $8ea79db61ca199dd$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $8ea79db61ca199dd$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $8ea79db61ca199dd$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $8ea79db61ca199dd$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $8ea79db61ca199dd$var$d(n.props.path).map($8ea79db61ca199dd$var$l).join("");
    }(n), n.props;
}
function $8ea79db61ca199dd$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $8ea79db61ca199dd$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $8ea79db61ca199dd$var$p = {}, $8ea79db61ca199dd$var$m = [], $8ea79db61ca199dd$var$y = [], $8ea79db61ca199dd$var$U = null, $8ea79db61ca199dd$var$g = {
    url: $8ea79db61ca199dd$export$dc90482e4ef07afd()
}, $8ea79db61ca199dd$var$k = (0, $7Do5B.createContext)($8ea79db61ca199dd$var$g);
function $8ea79db61ca199dd$export$9a302a45f65d0572() {
    var n = (0, $3aPmr.useContext)($8ea79db61ca199dd$var$k);
    if (n === $8ea79db61ca199dd$var$g) {
        var t = (0, $3aPmr.useState)()[1];
        (0, $3aPmr.useEffect)(function() {
            return $8ea79db61ca199dd$var$y.push(t), function() {
                return $8ea79db61ca199dd$var$y.splice($8ea79db61ca199dd$var$y.indexOf(t), 1);
            };
        }, []);
    }
    return [
        n,
        $8ea79db61ca199dd$export$4cb887bfde2d34ca
    ];
}
function $8ea79db61ca199dd$export$dc90482e4ef07afd() {
    var n;
    return "" + ((n = $8ea79db61ca199dd$var$U && $8ea79db61ca199dd$var$U.location ? $8ea79db61ca199dd$var$U.location : $8ea79db61ca199dd$var$U && $8ea79db61ca199dd$var$U.getCurrentLocation ? $8ea79db61ca199dd$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $8ea79db61ca199dd$var$p).pathname || "") + (n.search || "");
}
function $8ea79db61ca199dd$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var t = $8ea79db61ca199dd$var$m.length; t--;)if ($8ea79db61ca199dd$var$m[t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $8ea79db61ca199dd$var$U && $8ea79db61ca199dd$var$U[t] ? $8ea79db61ca199dd$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $8ea79db61ca199dd$var$I(n);
}
function $8ea79db61ca199dd$var$I(n) {
    for(var t = !1, r = 0; r < $8ea79db61ca199dd$var$m.length; r++)$8ea79db61ca199dd$var$m[r].routeTo(n) && (t = !0);
    return t;
}
function $8ea79db61ca199dd$var$M(n) {
    if (n && n.getAttribute) {
        var t = n.getAttribute("href"), r = n.getAttribute("target");
        if (t && t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $8ea79db61ca199dd$export$4cb887bfde2d34ca(t);
    }
}
function $8ea79db61ca199dd$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $8ea79db61ca199dd$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var t = n.target;
        do if ("a" === t.localName && t.getAttribute("href")) {
            if (t.hasAttribute("data-native") || t.hasAttribute("native")) return;
            if ($8ea79db61ca199dd$var$M(t)) return $8ea79db61ca199dd$var$b(n);
        }
        while (t = t.parentNode);
    }
}
var $8ea79db61ca199dd$var$w = !1;
function $8ea79db61ca199dd$export$55185c17a0fcbe46(n) {
    n.history && ($8ea79db61ca199dd$var$U = n.history), this.state = {
        url: n.url || $8ea79db61ca199dd$export$dc90482e4ef07afd()
    };
}
$8ea79db61ca199dd$var$c($8ea79db61ca199dd$export$55185c17a0fcbe46.prototype = new (0, $7Do5B.Component), {
    shouldComponentUpdate: function(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function(n) {
        var t = (0, $7Do5B.toChildArray)(this.props.children);
        return void 0 !== this.g(t, n);
    },
    routeTo: function(n) {
        this.setState({
            url: n
        });
        var t = this.canRoute(n);
        return this.p || this.forceUpdate(), t;
    },
    componentWillMount: function() {
        this.p = !0;
    },
    componentDidMount: function() {
        var n = this;
        $8ea79db61ca199dd$var$w || ($8ea79db61ca199dd$var$w = !0, $8ea79db61ca199dd$var$U || addEventListener("popstate", function() {
            $8ea79db61ca199dd$var$I($8ea79db61ca199dd$export$dc90482e4ef07afd());
        }), addEventListener("click", $8ea79db61ca199dd$var$W)), $8ea79db61ca199dd$var$m.push(this), $8ea79db61ca199dd$var$U && (this.u = $8ea79db61ca199dd$var$U.listen(function(t) {
            var r = t.location || t;
            n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function() {
        "function" == typeof this.u && this.u(), $8ea79db61ca199dd$var$m.splice($8ea79db61ca199dd$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function() {
        this.p = !0;
    },
    componentDidUpdate: function() {
        this.p = !1;
    },
    g: function(n, t) {
        n = n.filter($8ea79db61ca199dd$var$v).sort($8ea79db61ca199dd$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $8ea79db61ca199dd$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $7Do5B.toChildArray)(n.children), a);
        if (h && (u = (0, $7Do5B.cloneElement)(h[0], $8ea79db61ca199dd$var$c($8ea79db61ca199dd$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $8ea79db61ca199dd$var$c($8ea79db61ca199dd$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $8ea79db61ca199dd$var$y.length; v--;)$8ea79db61ca199dd$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $7Do5B.h)($8ea79db61ca199dd$var$k.Provider, {
            value: s
        }, u);
    }
});
var $8ea79db61ca199dd$export$a6c7ac8248d6e38a = function(n) {
    return (0, $7Do5B.h)("a", $8ea79db61ca199dd$var$c({
        onClick: $8ea79db61ca199dd$var$W
    }, n));
}, $8ea79db61ca199dd$export$e7b0ac011bb776c6 = function(n) {
    return (0, $7Do5B.h)(n.component, n);
};

});
parcelRegister("3aPmr", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $24fa25825a717dc7$export$60241385465d0a34; });
$parcel$export(module.exports, "useEffect", function () { return $24fa25825a717dc7$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useRef", function () { return $24fa25825a717dc7$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $24fa25825a717dc7$export$1538c33de8887b59; });
$parcel$export(module.exports, "useContext", function () { return $24fa25825a717dc7$export$fae74005e78b1a27; });

var $7Do5B = parcelRequire("7Do5B");
var $24fa25825a717dc7$var$t, $24fa25825a717dc7$var$r, $24fa25825a717dc7$var$u, $24fa25825a717dc7$var$i, $24fa25825a717dc7$var$o = 0, $24fa25825a717dc7$var$f = [], $24fa25825a717dc7$var$c = (0, $7Do5B.options), $24fa25825a717dc7$var$e = $24fa25825a717dc7$var$c.__b, $24fa25825a717dc7$var$a = $24fa25825a717dc7$var$c.__r, $24fa25825a717dc7$var$v = $24fa25825a717dc7$var$c.diffed, $24fa25825a717dc7$var$l = $24fa25825a717dc7$var$c.__c, $24fa25825a717dc7$var$m = $24fa25825a717dc7$var$c.unmount, $24fa25825a717dc7$var$s = $24fa25825a717dc7$var$c.__;
function $24fa25825a717dc7$var$p(n, t) {
    $24fa25825a717dc7$var$c.__h && $24fa25825a717dc7$var$c.__h($24fa25825a717dc7$var$r, n, $24fa25825a717dc7$var$o || t), $24fa25825a717dc7$var$o = 0;
    var u = $24fa25825a717dc7$var$r.__H || ($24fa25825a717dc7$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $24fa25825a717dc7$export$60241385465d0a34(n) {
    return $24fa25825a717dc7$var$o = 1, $24fa25825a717dc7$export$13e3392192263954($24fa25825a717dc7$var$D, n);
}
function $24fa25825a717dc7$export$13e3392192263954(n, u, i) {
    var o = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $24fa25825a717dc7$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $24fa25825a717dc7$var$r, !$24fa25825a717dc7$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $24fa25825a717dc7$var$r.__f = !0;
        var c = $24fa25825a717dc7$var$r.shouldComponentUpdate, e = $24fa25825a717dc7$var$r.componentWillUpdate;
        $24fa25825a717dc7$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $24fa25825a717dc7$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $24fa25825a717dc7$export$6d9c69b0de29b591(n, u) {
    var i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 3);
    !$24fa25825a717dc7$var$c.__s && $24fa25825a717dc7$var$C(i.__H, u) && (i.__ = n, i.u = u, $24fa25825a717dc7$var$r.__H.__h.push(i));
}
function $24fa25825a717dc7$export$e5c5a5f917a5871c(n, u) {
    var i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 4);
    !$24fa25825a717dc7$var$c.__s && $24fa25825a717dc7$var$C(i.__H, u) && (i.__ = n, i.u = u, $24fa25825a717dc7$var$r.__h.push(i));
}
function $24fa25825a717dc7$export$b8f5890fc79d6aca(n) {
    return $24fa25825a717dc7$var$o = 5, $24fa25825a717dc7$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $24fa25825a717dc7$export$d5a552a76deda3c2(n, t, r) {
    $24fa25825a717dc7$var$o = 6, $24fa25825a717dc7$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $24fa25825a717dc7$export$1538c33de8887b59(n, r) {
    var u = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 7);
    return $24fa25825a717dc7$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $24fa25825a717dc7$export$35808ee640e87ca7(n, t) {
    return $24fa25825a717dc7$var$o = 8, $24fa25825a717dc7$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $24fa25825a717dc7$export$fae74005e78b1a27(n) {
    var u = $24fa25825a717dc7$var$r.context[n.__c], i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($24fa25825a717dc7$var$r)), u.props.value) : n.__;
}
function $24fa25825a717dc7$export$dc8fbce3eb94dc1e(n, t) {
    $24fa25825a717dc7$var$c.useDebugValue && $24fa25825a717dc7$var$c.useDebugValue(t ? t(n) : n);
}
function $24fa25825a717dc7$export$c052f6604b7d51fe(n) {
    var u = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 10), i = $24fa25825a717dc7$export$60241385465d0a34();
    return u.__ = n, $24fa25825a717dc7$var$r.componentDidCatch || ($24fa25825a717dc7$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $24fa25825a717dc7$export$f680877a34711e37() {
    var n = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 11);
    if (!n.__) {
        for(var u = $24fa25825a717dc7$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $24fa25825a717dc7$var$j() {
    for(var n; n = $24fa25825a717dc7$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($24fa25825a717dc7$var$z), n.__H.__h.forEach($24fa25825a717dc7$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $24fa25825a717dc7$var$c.__e(t, n.__v);
    }
}
$24fa25825a717dc7$var$c.__b = function(n) {
    $24fa25825a717dc7$var$r = null, $24fa25825a717dc7$var$e && $24fa25825a717dc7$var$e(n);
}, $24fa25825a717dc7$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $24fa25825a717dc7$var$s && $24fa25825a717dc7$var$s(n, t);
}, $24fa25825a717dc7$var$c.__r = function(n) {
    $24fa25825a717dc7$var$a && $24fa25825a717dc7$var$a(n), $24fa25825a717dc7$var$t = 0;
    var i = ($24fa25825a717dc7$var$r = n.__c).__H;
    i && ($24fa25825a717dc7$var$u === $24fa25825a717dc7$var$r ? (i.__h = [], $24fa25825a717dc7$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($24fa25825a717dc7$var$z), i.__h.forEach($24fa25825a717dc7$var$B), i.__h = [], $24fa25825a717dc7$var$t = 0)), $24fa25825a717dc7$var$u = $24fa25825a717dc7$var$r;
}, $24fa25825a717dc7$var$c.diffed = function(n) {
    $24fa25825a717dc7$var$v && $24fa25825a717dc7$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $24fa25825a717dc7$var$f.push(t) && $24fa25825a717dc7$var$i === $24fa25825a717dc7$var$c.requestAnimationFrame || (($24fa25825a717dc7$var$i = $24fa25825a717dc7$var$c.requestAnimationFrame) || $24fa25825a717dc7$var$w)($24fa25825a717dc7$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $24fa25825a717dc7$var$u = $24fa25825a717dc7$var$r = null;
}, $24fa25825a717dc7$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($24fa25825a717dc7$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $24fa25825a717dc7$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $24fa25825a717dc7$var$c.__e(r, n.__v);
        }
    }), $24fa25825a717dc7$var$l && $24fa25825a717dc7$var$l(n, t);
}, $24fa25825a717dc7$var$c.unmount = function(n) {
    $24fa25825a717dc7$var$m && $24fa25825a717dc7$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $24fa25825a717dc7$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $24fa25825a717dc7$var$c.__e(t, r.__v));
};
var $24fa25825a717dc7$var$k = "function" == typeof requestAnimationFrame;
function $24fa25825a717dc7$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $24fa25825a717dc7$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $24fa25825a717dc7$var$k && (t = requestAnimationFrame(r));
}
function $24fa25825a717dc7$var$z(n) {
    var t = $24fa25825a717dc7$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $24fa25825a717dc7$var$r = t;
}
function $24fa25825a717dc7$var$B(n) {
    var t = $24fa25825a717dc7$var$r;
    n.__c = n.__(), $24fa25825a717dc7$var$r = t;
}
function $24fa25825a717dc7$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $24fa25825a717dc7$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});


parcelRegister("9tqvu", function(module, exports) {

$parcel$export(module.exports, "PAGES_EN", function () { return $3f4a03403083c83c$export$7e5c5cc34340ebd9; });
$parcel$export(module.exports, "getRoutesByLocale", function () { return $3f4a03403083c83c$export$48094e400b6de4cd; });
const $3f4a03403083c83c$export$7e5c5cc34340ebd9 = {
    HOME: '/',
    ABOUT: '/about/',
    CONSTELLATION: '/constellation/',
    LEGAL: '/legal/',
    ARTISTS: '/artists/',
    CHAPTERS: '/chapters/'
};
const $3f4a03403083c83c$export$3b27b1608f1c0fbf = {
    HOME: '/de/',
    ABOUT: '/de/about/',
    CONSTELLATION: '/de/constellation/',
    LEGAL: '/de/impressum/',
    ARTISTS: '/de/artists/',
    CHAPTERS: '/de/chapters/'
};
const $3f4a03403083c83c$export$48094e400b6de4cd = (lang)=>{
    if (lang === 'de') return $3f4a03403083c83c$export$3b27b1608f1c0fbf;
    if (lang === 'en') return $3f4a03403083c83c$export$7e5c5cc34340ebd9;
};

});

parcelRegister("jZHGC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d58efc9fb8dbc0ce$export$2e2bcd8739ae039; });
const $d58efc9fb8dbc0ce$var$useLocale = ()=>{
    return 'en';
};
var $d58efc9fb8dbc0ce$export$2e2bcd8739ae039 = $d58efc9fb8dbc0ce$var$useLocale;

});

parcelRegister("hZVpX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99fbe9004726beba$export$2e2bcd8739ae039; });

var $7Do5B = parcelRequire("7Do5B");

var $990qa = parcelRequire("990qa");
const $99fbe9004726beba$var$Container = (props)=>{
    const { className: className, style: style, ...rest } = props;
    const hasClass = className ? className : '';
    let css = `${$990qa.container} ${hasClass}`?.trimEnd();
    return /*#__PURE__*/ (0, $7Do5B.h)("section", {
        className: css,
        style: style,
        ...rest
    }, props.children);
};
var $99fbe9004726beba$export$2e2bcd8739ae039 = $99fbe9004726beba$var$Container;

});
parcelRegister("990qa", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $6a8547f361f5cbe2$export$34e0f9847d4c02dd; }, function (v) { return $6a8547f361f5cbe2$export$34e0f9847d4c02dd = v; });
var $6a8547f361f5cbe2$export$34e0f9847d4c02dd;
$6a8547f361f5cbe2$export$34e0f9847d4c02dd = `_7ZOsUa_container`;

});


parcelRegister("gtCRT", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("aUxw2")),
    $parcel$import("20bVH")
]).then(()=>parcelRequire('284wx'));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $84c702df89f2997b$var$cachedPreloads;
        case 'prefetch':
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dvTdO", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("cPBXS")),
    (parcelRequire("7jkLd"))($parcel$resolve("1IgdO")),
    $parcel$import("k9EmW"),
    $parcel$import("cl207")
]).then(()=>parcelRequire('huPu1'));

});

parcelRegister("3Pxf1", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("fBpId")),
    $parcel$import("6cmWD")
]).then(()=>parcelRequire('gDDy3'));

});

parcelRegister("ffBXi", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("1IgdO")),
    $parcel$import("k9EmW")
]).then(()=>parcelRequire('cs4Zh'));

});

parcelRegister("9Lew4", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("9fM7C")),
    (parcelRequire("7jkLd"))($parcel$resolve("1IgdO")),
    $parcel$import("k9EmW"),
    $parcel$import("iiGQH")
]).then(()=>parcelRequire('lJo4q'));

});

parcelRegister("dcjvn", function(module, exports) {
module.exports = JSON.parse('{"home":{"title":"I am here with my presence, curiosity, and some necessary chaos. Operating in the realms of the unconventional and experimental, I aim to bring back the balance between you and the surrounding nature.. So both can finally flourish in their full power again. Let\'s connect for a while and figure it out. When did you lose your curiosity? This trip on earth is supposed to be enjoyable. Maybe I can make you remember\u2026"},"about":{"title":"What I offer","intro":"My intuition guided me towards shaping the role of the contemporary shaman, towards creating a new myth. Through methods of art, intuition, meditation, and other more traditional shamanic tools, I offer help to bring back balance. To inspire and to enable you to gain your power back to act and create in this world."},"code":{"title":"Code of Ethics"}}');

});

parcelRegister("hBXto", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $211b850704a14286$export$2e2bcd8739ae039; });

var $3aPmr = parcelRequire("3aPmr");
const $211b850704a14286$var$useMediaQuery = (query)=>{
    const getMatches = (query)=>{
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return false;
    };
    const [matches, setMatches] = (0, $3aPmr.useState)(getMatches(query));
    (0, $3aPmr.useEffect)(()=>{
        const mediaQueryList = window.matchMedia(query);
        const listener = (event)=>setMatches(event.matches);
        mediaQueryList.addEventListener("change", listener);
        return ()=>mediaQueryList.removeEventListener("change", listener);
    }, [
        query
    ]);
    return matches;
};
var $211b850704a14286$export$2e2bcd8739ae039 = $211b850704a14286$var$useMediaQuery;

});

parcelRegister("6WvJn", function(module, exports) {
module.exports = $parcel$import("b5b0S").then(()=>parcelRequire('apSC7'));

});

var $c921b86e8b2a8e8f$exports = {};
$parcel$extendImportMap({
    "kWOWI": "key.b73ffd75.png",
    "20bVH": "Home.e03adbaf.js",
    "aUxw2": "Home.5fd7178f.css",
    "cl207": "About.8fabffe0.js",
    "k9EmW": "Artists.e04c5fa1.js",
    "1IgdO": "Artists.5579e731.css",
    "cPBXS": "About.03d47643.css",
    "6cmWD": "Constellation.e1fe64b1.js",
    "fBpId": "Constellation.088dd7ef.css",
    "iiGQH": "Chapters.b8fee0d5.js",
    "9fM7C": "Chapters.bf4a5786.css",
    "4J3ks": "r_k.bde2ec3a.jpeg",
    "5BAP7": "gate.fda8c61e.png",
    "b5b0S": "de.9ee00768.js"
});


var $7Do5B = parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");

var $cflzh = parcelRequire("cflzh");

var $9tqvu = parcelRequire("9tqvu");

var $jZHGC = parcelRequire("jZHGC");

var $hZVpX = parcelRequire("hZVpX");
var $b9525fb6bfb66c04$export$6565f9f03506010b;
var $b9525fb6bfb66c04$export$adb608be33961c98;
var $b9525fb6bfb66c04$export$7061c75fc5af8b7e;
var $b9525fb6bfb66c04$export$17a1664ed1fb5d6f;
$b9525fb6bfb66c04$export$6565f9f03506010b = `BOBUQq_code`;
$b9525fb6bfb66c04$export$adb608be33961c98 = `BOBUQq_footer`;
$b9525fb6bfb66c04$export$7061c75fc5af8b7e = `BOBUQq_item`;
$b9525fb6bfb66c04$export$17a1664ed1fb5d6f = `BOBUQq_items`;


// TODO: similar style as header? :D
const $efe4c661c5a2a935$var$Footer = ()=>{
    const locale = (0, $jZHGC.default)();
    const routes = (0, $9tqvu.getRoutesByLocale)(locale);
    return /*#__PURE__*/ (0, $7Do5B.h)("footer", {
        className: $b9525fb6bfb66c04$export$adb608be33961c98
    }, /*#__PURE__*/ (0, $7Do5B.h)((0, $hZVpX.default), {
        style: {
            marginTop: 0
        }
    }, /*#__PURE__*/ (0, $7Do5B.h)("div", {
        style: {
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, $7Do5B.h)("ul", {
        className: $b9525fb6bfb66c04$export$17a1664ed1fb5d6f,
        style: {
            display: 'flex'
        }
    }, /*#__PURE__*/ (0, $7Do5B.h)("li", {
        className: $b9525fb6bfb66c04$export$7061c75fc5af8b7e
    }, /*#__PURE__*/ (0, $7Do5B.h)((0, $cflzh.Link), {
        href: routes.CODE
    }, "\uD83C\uDF75", ' ', /*#__PURE__*/ (0, $7Do5B.h)("span", {
        style: {
            display: 'inline-block'
        },
        className: $b9525fb6bfb66c04$export$6565f9f03506010b
    }, ' ', "code of"), ' ', "ethics"), ' '), false, /*#__PURE__*/ (0, $7Do5B.h)("li", {
        className: $b9525fb6bfb66c04$export$7061c75fc5af8b7e
    }, /*#__PURE__*/ (0, $7Do5B.h)((0, $cflzh.Link), {
        href: routes.LEGAL
    }, "\u2696\uFE0F legal"), ' ')))));
};
var $efe4c661c5a2a935$export$2e2bcd8739ae039 = $efe4c661c5a2a935$var$Footer;



var $7Do5B = parcelRequire("7Do5B");

var $cflzh = parcelRequire("cflzh");
var $93264069bda87c03$exports = {};

(function(global, factory) {
    $93264069bda87c03$exports = factory((parcelRequire("7Do5B")));
})($93264069bda87c03$exports, function(preact) {
    'use strict';
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var AsyncRoute = function(_Component) {
        _inherits(AsyncRoute, _Component);
        function AsyncRoute() {
            _classCallCheck(this, AsyncRoute);
            var _this = _possibleConstructorReturn(this, _Component.call(this));
            _this.state = {
                componentData: null
            };
            return _this;
        }
        AsyncRoute.prototype.loadComponent = function loadComponent() {
            var _this2 = this;
            if (this.props.component) return this.setState({
                componentData: this.props.component
            });
            var componentData = this.props.getComponent(this.props.url, function(_ref) {
                var component = _ref.component;
                // Named param for making callback future proof
                if (component) _this2.setState({
                    componentData: component
                });
            }, _extends({}, this.props, this.props.matches));
            // In case returned value was a promise
            if (componentData && componentData.then) // IIFE to check if a later ending promise was creating a race condition
            // Check test case for more info
            (function(url) {
                componentData.then(function(component) {
                    if (url !== _this2.props.url) {
                        _this2.setState({
                            componentData: null
                        }, function() {
                            _this2.loadComponent();
                        });
                        return;
                    }
                    _this2.setState({
                        componentData: component
                    });
                });
            })(this.props.url);
        };
        AsyncRoute.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var _this3 = this;
            if (this.props.path && this.props.path !== nextProps.path) this.setState({
                componentData: null
            }, function() {
                _this3.loadComponent();
            });
        };
        AsyncRoute.prototype.componentWillMount = function componentWillMount() {
            this.loadComponent();
        };
        AsyncRoute.prototype.render = function render() {
            if (this.state.componentData) return preact.h(this.state.componentData, this.props);
            else if (this.props.loading) {
                var loadingComponent = this.props.loading();
                return loadingComponent;
            }
            return null;
        };
        return AsyncRoute;
    }(preact.Component);
    return AsyncRoute;
});



var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
var $bf2250ced309a149$export$a19185d1233fc4b2;
var $bf2250ced309a149$export$bfd64c937657f93a;
var $bf2250ced309a149$export$cc74dcc53cfce4eb;
$bf2250ced309a149$export$a19185d1233fc4b2 = `ZMO6Uq_emoji`;
$bf2250ced309a149$export$bfd64c937657f93a = `ZMO6Uq_rotating`;
$bf2250ced309a149$export$bfd64c937657f93a;
$bf2250ced309a149$export$cc74dcc53cfce4eb = `ZMO6Uq_wrapper`;



const $943a1689775f3cf6$export$eee0bf7dd5031e5a = 'initalLoading';


// TODO: find better loading spinner? maybe "R? 
const $6e5fab5b7bdf911b$var$Loading = ()=>{
    (0, $3aPmr.useEffect)(()=>{
        document.body.classList.add('loading');
        // if key does not exist, it is the first page load
        if (!localStorage.getItem((0, $943a1689775f3cf6$export$eee0bf7dd5031e5a))) {
            document.body.classList.add('initalLoading');
            localStorage.setItem((0, $943a1689775f3cf6$export$eee0bf7dd5031e5a), 'true');
        }
        return ()=>{
            document.body.classList.remove('loading');
            document.body.classList.remove('initalLoading');
        };
    }, []);
    return /*#__PURE__*/ (0, $7Do5B.h)("div", {
        className: $bf2250ced309a149$export$cc74dcc53cfce4eb
    }, /*#__PURE__*/ (0, $7Do5B.h)("div", {
        class: $bf2250ced309a149$export$a19185d1233fc4b2
    }, /*#__PURE__*/ (0, $7Do5B.h)("img", {
        width: "110",
        src: (0, {})
    })));
};
var $6e5fab5b7bdf911b$export$2e2bcd8739ae039 = $6e5fab5b7bdf911b$var$Loading;



var $jZHGC = parcelRequire("jZHGC");

var $3aPmr = parcelRequire("3aPmr");
const $5648240c50356196$var$useCurrentRoute = ()=>{
    const [currentPath, setCurrentPath] = (0, $3aPmr.useState)(window.location.pathname);
    (0, $3aPmr.useEffect)(()=>{
        const handleRouteChange = ()=>{
            setCurrentPath(window.location.pathname);
        };
        // Listen for popstate events (back/forward navigation)
        window.addEventListener('popstate', handleRouteChange);
        // Listen for pushstate/replacestate events (programmatic navigation)
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(window.history, args);
            handleRouteChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(window.history, args);
            handleRouteChange();
        };
        // Also listen for custom route change events that preact-router might emit
        const handleCustomRouteChange = ()=>{
            setCurrentPath(window.location.pathname);
        };
        // Listen for any custom events that might be emitted during navigation
        window.addEventListener('routechange', handleCustomRouteChange);
        return ()=>{
            window.removeEventListener('popstate', handleRouteChange);
            window.removeEventListener('routechange', handleCustomRouteChange);
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, []);
    return currentPath;
};
var $5648240c50356196$export$2e2bcd8739ae039 = $5648240c50356196$var$useCurrentRoute;



var $9tqvu = parcelRequire("9tqvu");

// TODO: generate routes from route array?
const $ab7ed3762a5ae72a$var$HOME = ()=>(parcelRequire("gtCRT")).then((module)=>module.default);

const $ab7ed3762a5ae72a$var$ABOUT = ()=>(parcelRequire("dvTdO")).then((module)=>module.default);

const $ab7ed3762a5ae72a$var$CONSTELLATION = ()=>(parcelRequire("3Pxf1")).then((module)=>module.default);

const $ab7ed3762a5ae72a$var$ARTISTS = ()=>(parcelRequire("ffBXi")).then((module)=>module.default);

const $ab7ed3762a5ae72a$var$CHAPTERS = ()=>(parcelRequire("9Lew4")).then((module)=>module.default);
const $ab7ed3762a5ae72a$var$Routes = ()=>{
    const locale = (0, $jZHGC.default)();
    const routes = (0, $9tqvu.getRoutesByLocale)(locale);
    const currentPath = (0, $5648240c50356196$export$2e2bcd8739ae039)();
    const handleRoute = (e)=>{
        // Scroll to top synchronously (this is fine)
        if (typeof window.scrollTo === 'function') window.scrollTo({
            top: 0,
            left: 0
        });
        // Emit custom event asynchronously to avoid interfering with router's update cycle
        // This ensures the router finishes rendering before other components react to the change
        requestAnimationFrame(()=>{
            window.dispatchEvent(new CustomEvent('routechange'));
        });
    };
    // Check if current path matches home route
    const isHomePage = currentPath === routes.HOME;
    return /*#__PURE__*/ (0, $7Do5B.h)("main", {
        className: isHomePage ? 'home-page' : ''
    }, /*#__PURE__*/ (0, $7Do5B.h)((0, $cflzh.default), {
        onChange: handleRoute,
        key: locale
    }, /*#__PURE__*/ (0, $7Do5B.h)((0, (/*@__PURE__*/$parcel$interopDefault($93264069bda87c03$exports))), {
        path: routes.HOME,
        getComponent: $ab7ed3762a5ae72a$var$HOME,
        loading: ()=>/*#__PURE__*/ (0, $7Do5B.h)((0, $6e5fab5b7bdf911b$export$2e2bcd8739ae039), null)
    }), /*#__PURE__*/ (0, $7Do5B.h)((0, (/*@__PURE__*/$parcel$interopDefault($93264069bda87c03$exports))), {
        path: routes.ABOUT,
        getComponent: $ab7ed3762a5ae72a$var$ABOUT,
        loading: ()=>/*#__PURE__*/ (0, $7Do5B.h)((0, $6e5fab5b7bdf911b$export$2e2bcd8739ae039), null)
    }), /*#__PURE__*/ (0, $7Do5B.h)((0, (/*@__PURE__*/$parcel$interopDefault($93264069bda87c03$exports))), {
        path: routes.CONSTELLATION,
        getComponent: $ab7ed3762a5ae72a$var$CONSTELLATION,
        loading: ()=>/*#__PURE__*/ (0, $7Do5B.h)((0, $6e5fab5b7bdf911b$export$2e2bcd8739ae039), null)
    }), /*#__PURE__*/ (0, $7Do5B.h)((0, (/*@__PURE__*/$parcel$interopDefault($93264069bda87c03$exports))), {
        path: routes.ARTISTS,
        getComponent: $ab7ed3762a5ae72a$var$ARTISTS,
        loading: ()=>/*#__PURE__*/ (0, $7Do5B.h)((0, $6e5fab5b7bdf911b$export$2e2bcd8739ae039), null)
    }), /*#__PURE__*/ (0, $7Do5B.h)((0, (/*@__PURE__*/$parcel$interopDefault($93264069bda87c03$exports))), {
        path: routes.CHAPTERS,
        getComponent: $ab7ed3762a5ae72a$var$CHAPTERS,
        loading: ()=>/*#__PURE__*/ (0, $7Do5B.h)((0, $6e5fab5b7bdf911b$export$2e2bcd8739ae039), null)
    })));
};
var $ab7ed3762a5ae72a$export$2e2bcd8739ae039 = $ab7ed3762a5ae72a$var$Routes;



var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
var $5c01ac6799bcfe04$exports = {};
!function(t, n) {
    $5c01ac6799bcfe04$exports = function(t, n, e, i, o) {
        for(n = n.split ? n.split(".") : n, i = 0; i < n.length; i++)t = t ? t[n[i]] : o;
        return t === o ? e : t;
    };
}($5c01ac6799bcfe04$exports);


var $a8aa41921077fdaf$var$e = (0, $7Do5B.createContext)(), $a8aa41921077fdaf$export$480518999dfc4151 = function(n) {
    return (0, $7Do5B.h)($a8aa41921077fdaf$var$e.Provider, {
        value: n.dictionary
    }, n.children);
}, $a8aa41921077fdaf$export$5f1af8db9871e1d6 = function(r) {
    var n = r.id, i = r.plural, c = r.children, a = function(r, n) {
        var o = {};
        for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && -1 === n.indexOf(t) && (o[t] = r[t]);
        return o;
    }(r, [
        "id",
        "plural",
        "children"
    ]), u = (0, $3aPmr.useContext)($a8aa41921077fdaf$var$e), p = function(r, n) {
        return (n || 0 === n) && r && r.constructor === Object && (r = 0 === n ? r.none : 1 === n && r.one || r.many), r;
    }(n && (0, (/*@__PURE__*/$parcel$interopDefault($5c01ac6799bcfe04$exports)))(u, n), i);
    return ("function" == typeof p ? p(a) : p) || c;
};



var $dcjvn = parcelRequire("dcjvn");

var $3aPmr = parcelRequire("3aPmr");


var $7Do5B = parcelRequire("7Do5B");

var $cflzh = parcelRequire("cflzh");
var $f0572b412e352205$exports = {};

$parcel$export($f0572b412e352205$exports, "active", function () { return $f0572b412e352205$export$89da14300d534261; }, function (v) { return $f0572b412e352205$export$89da14300d534261 = v; });
$parcel$export($f0572b412e352205$exports, "bottomLeft", function () { return $f0572b412e352205$export$5909307a9e24921b; }, function (v) { return $f0572b412e352205$export$5909307a9e24921b = v; });
$parcel$export($f0572b412e352205$exports, "bottomRight", function () { return $f0572b412e352205$export$310433d43d4a6657; }, function (v) { return $f0572b412e352205$export$310433d43d4a6657 = v; });
$parcel$export($f0572b412e352205$exports, "logo", function () { return $f0572b412e352205$export$db3c28d99448dcff; }, function (v) { return $f0572b412e352205$export$db3c28d99448dcff = v; });
$parcel$export($f0572b412e352205$exports, "menuItem", function () { return $f0572b412e352205$export$c176f998e71d0f08; }, function (v) { return $f0572b412e352205$export$c176f998e71d0f08 = v; });
$parcel$export($f0572b412e352205$exports, "nav", function () { return $f0572b412e352205$export$80e4b313e5e6b30d; }, function (v) { return $f0572b412e352205$export$80e4b313e5e6b30d = v; });
$parcel$export($f0572b412e352205$exports, "rkMenu", function () { return $f0572b412e352205$export$d0e7bec093d7a3bb; }, function (v) { return $f0572b412e352205$export$d0e7bec093d7a3bb = v; });
$parcel$export($f0572b412e352205$exports, "topLeft", function () { return $f0572b412e352205$export$b36ce604e2cd7590; }, function (v) { return $f0572b412e352205$export$b36ce604e2cd7590 = v; });
$parcel$export($f0572b412e352205$exports, "topRight", function () { return $f0572b412e352205$export$eff07f92f1a4dad9; }, function (v) { return $f0572b412e352205$export$eff07f92f1a4dad9 = v; });
var $f0572b412e352205$export$89da14300d534261;
var $f0572b412e352205$export$5909307a9e24921b;
var $f0572b412e352205$export$310433d43d4a6657;
var $f0572b412e352205$export$db3c28d99448dcff;
var $f0572b412e352205$export$c176f998e71d0f08;
var $f0572b412e352205$export$80e4b313e5e6b30d;
var $f0572b412e352205$export$d0e7bec093d7a3bb;
var $f0572b412e352205$export$b36ce604e2cd7590;
var $f0572b412e352205$export$eff07f92f1a4dad9;
$f0572b412e352205$export$89da14300d534261 = `Caym7a_active`;
$f0572b412e352205$export$5909307a9e24921b = `Caym7a_bottomLeft`;
$f0572b412e352205$export$310433d43d4a6657 = `Caym7a_bottomRight`;
$f0572b412e352205$export$db3c28d99448dcff = `Caym7a_logo`;
$f0572b412e352205$export$c176f998e71d0f08 = `Caym7a_menuItem`;
$f0572b412e352205$export$80e4b313e5e6b30d = `Caym7a_nav`;
$f0572b412e352205$export$d0e7bec093d7a3bb = `Caym7a_rkMenu`;
$f0572b412e352205$export$b36ce604e2cd7590 = `Caym7a_topLeft`;
$f0572b412e352205$export$eff07f92f1a4dad9 = `Caym7a_topRight`;



var $9tqvu = parcelRequire("9tqvu");

var $jZHGC = parcelRequire("jZHGC");


var $7Do5B = parcelRequire("7Do5B");

var $cflzh = parcelRequire("cflzh");

var $3aPmr = parcelRequire("3aPmr");

var $9tqvu = parcelRequire("9tqvu");

var $3aPmr = parcelRequire("3aPmr");
const $19e8244ec1cc0b39$var$useOuterClick = (callback)=>{
    const callbackRef = (0, $3aPmr.useRef)();
    const innerRef = (0, $3aPmr.useRef)(null);
    (0, $3aPmr.useEffect)(()=>{
        callbackRef.current = callback;
    });
    (0, $3aPmr.useEffect)(()=>{
        document.addEventListener('click', _onClick);
        return ()=>document.removeEventListener('click', _onClick);
        function _onClick(e) {
            const clickedOutside = !innerRef.current?.contains(e.target);
            if (clickedOutside) callbackRef.current?.(e);
        }
    }, []);
    return innerRef;
};
var $19e8244ec1cc0b39$export$2e2bcd8739ae039 = $19e8244ec1cc0b39$var$useOuterClick;


var $7426944ef075f979$export$89da14300d534261;
var $7426944ef075f979$export$284301afa5bb28f9;
var $7426944ef075f979$export$36e7aa3b8bf8703a;
var $7426944ef075f979$export$9f42c466da956b3;
var $7426944ef075f979$export$64a53ecd158b85c4;
var $7426944ef075f979$export$4df8d4373bc60300;
var $7426944ef075f979$export$2687b9d1800d87ff;
var $7426944ef075f979$export$2e33e1187efa1113;
$7426944ef075f979$export$89da14300d534261 = `_7k0AMq_active`;
$7426944ef075f979$export$284301afa5bb28f9 = `_7k0AMq_activeNavItem`;
$7426944ef075f979$export$36e7aa3b8bf8703a = `_7k0AMq_backgroundBlur`;
$7426944ef075f979$export$9f42c466da956b3 = `_7k0AMq_burger`;
$7426944ef075f979$export$64a53ecd158b85c4 = `_7k0AMq_closeIcon`;
$7426944ef075f979$export$4df8d4373bc60300 = `_7k0AMq_drawer`;
$7426944ef075f979$export$2687b9d1800d87ff = `_7k0AMq_drawerMenu`;
$7426944ef075f979$export$2e33e1187efa1113 = `_7k0AMq_drawerMenuItem`;


const $627acf444263479a$var$MENU = [
    {
        text: 'About',
        href: (0, $9tqvu.PAGES_EN).ABOUT
    },
    {
        text: 'Chapters',
        href: (0, $9tqvu.PAGES_EN).CHAPTERS
    },
    {
        text: 'Artists',
        href: (0, $9tqvu.PAGES_EN).ARTISTS
    }
];
const $627acf444263479a$var$BurgerMenu = ()=>{
    const [isOpen, setIsOpen] = (0, $3aPmr.useState)(false);
    const ref = (0, $19e8244ec1cc0b39$export$2e2bcd8739ae039)(()=>setIsOpen(false));
    (0, $3aPmr.useEffect)(()=>{
        const body = document.body.classList;
        const root = document.documentElement.classList;
        toggle(body);
        toggle(root);
        return ()=>{
            document.body.classList.remove('u-overflow-y-hidden');
            document.documentElement.classList.remove('u-overflow-y-hidden');
        };
    }, [
        isOpen
    ]);
    const toggle = (element)=>{
        isOpen ? element.add('u-overflow-y-hidden') : element.remove('u-overflow-y-hidden');
    };
    const close = ()=>setIsOpen(false);
    return /*#__PURE__*/ (0, $7Do5B.h)("nav", {
        className: `${isOpen ? $7426944ef075f979$export$89da14300d534261 : ''}`,
        ref: ref
    }, /*#__PURE__*/ (0, $7Do5B.h)("div", {
        className: `${$7426944ef075f979$export$9f42c466da956b3}`,
        onClick: ()=>setIsOpen(!isOpen)
    }, /*#__PURE__*/ (0, $7Do5B.h)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "data-name": "Layer 1",
        viewBox: "0 0 52 52"
    }, /*#__PURE__*/ (0, $7Do5B.h)("path", {
        d: "M50 12.5H2a2 2 0 0 1 0-4h48a2 2 0 0 1 0 4ZM50 28H2a2 2 0 0 1 0-4h48a2 2 0 0 1 0 4ZM50 43.5H2a2 2 0 0 1 0-4h48a2 2 0 0 1 0 4Z"
    }))), /*#__PURE__*/ (0, $7Do5B.h)("div", {
        className: $7426944ef075f979$export$4df8d4373bc60300,
        style: {
            display: isOpen ? 'flex' : 'none'
        }
    }, /*#__PURE__*/ (0, $7Do5B.h)("div", {
        className: $7426944ef075f979$export$64a53ecd158b85c4,
        onClick: ()=>setIsOpen(false)
    }, "\u2715"), /*#__PURE__*/ (0, $7Do5B.h)("ul", {
        className: $7426944ef075f979$export$2687b9d1800d87ff
    }, $627acf444263479a$var$MENU.map((item)=>/*#__PURE__*/ (0, $7Do5B.h)("li", {
            className: $7426944ef075f979$export$2e33e1187efa1113
        }, /*#__PURE__*/ (0, $7Do5B.h)((0, $cflzh.Link), {
            href: item.href,
            onClick: close
        }, item.text))))), isOpen && /*#__PURE__*/ (0, $7Do5B.h)("div", {
        className: $7426944ef075f979$export$36e7aa3b8bf8703a,
        onClick: close
    }));
};
var $627acf444263479a$export$2e2bcd8739ae039 = $627acf444263479a$var$BurgerMenu;



var $hBXto = parcelRequire("hBXto");

var $3aPmr = parcelRequire("3aPmr");
var $a5cf0f2a739ac89a$exports = {};
$a5cf0f2a739ac89a$exports = $parcel$resolve("4J3ks");


const $ef52437885d17bc2$var$logoUrl = new URL($a5cf0f2a739ac89a$exports).href;
const $ef52437885d17bc2$var$RKMenu = ({ items: items })=>{
    const locale = (0, $jZHGC.default)();
    const currentRoute = (0, $5648240c50356196$export$2e2bcd8739ae039)();
    const routes = (0, $9tqvu.getRoutesByLocale)(locale);
    const isTablet = (0, $hBXto.default)("(min-width: 600px)");
    const defaultItems = [
        {
            href: routes.ABOUT,
            label: "About ",
            position: "topRight"
        },
        {
            href: routes.CHAPTERS,
            label: "Chapters",
            position: "bottomLeft"
        },
        {
            href: routes.ARTISTS,
            label: "Artists",
            position: "topLeft"
        }
    ];
    const menuItems = items || defaultItems;
    (0, $3aPmr.useEffect)(()=>{
        console.log(isTablet);
    }, [
        isTablet
    ]);
    return /*#__PURE__*/ (0, $7Do5B.h)("div", {
        className: $f0572b412e352205$exports.rkMenu
    }, /*#__PURE__*/ (0, $7Do5B.h)((0, $cflzh.Link), {
        href: routes.HOME
    }, /*#__PURE__*/ (0, $7Do5B.h)("img", {
        className: $f0572b412e352205$exports.logo,
        src: $ef52437885d17bc2$var$logoUrl
    })), isTablet ? /*#__PURE__*/ (0, $7Do5B.h)((0, $7Do5B.Fragment), null, /*#__PURE__*/ (0, $7Do5B.h)("nav", {
        className: $f0572b412e352205$exports.nav
    }, menuItems.map((item, index)=>{
        const isActive = currentRoute === item.href;
        return /*#__PURE__*/ (0, $7Do5B.h)("div", {
            key: item.position
        }, /*#__PURE__*/ (0, $7Do5B.h)((0, $cflzh.Link), {
            href: item.href,
            className: `${$f0572b412e352205$exports.menuItem} ${$f0572b412e352205$exports[item.position]} ${isActive ? $f0572b412e352205$exports.active : ""} ${index === 0 ? "artists" : ""}`
        }, item.label));
    }))) : /*#__PURE__*/ (0, $7Do5B.h)((0, $7Do5B.Fragment), null, /*#__PURE__*/ (0, $7Do5B.h)((0, $627acf444263479a$export$2e2bcd8739ae039), null)));
};
var $ef52437885d17bc2$export$2e2bcd8739ae039 = $ef52437885d17bc2$var$RKMenu;




var $jZHGC = parcelRequire("jZHGC");

var $9tqvu = parcelRequire("9tqvu");

var $3aPmr = parcelRequire("3aPmr");
const $978db4e278a019b6$export$cf4c059935abd024 = (shouldBeActive = true)=>{
    const canvasRef = (0, $3aPmr.useRef)(null);
    (0, $3aPmr.useEffect)(()=>{
        if (!shouldBeActive) {
            console.log('Rising clouds disabled');
            return;
        }
        const canvas = document.createElement('canvas');
        canvasRef.current = canvas;
        canvas.style.position = 'fixed';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.pointerEvents = 'none'; // click-through
        canvas.style.zIndex = '-1'; // above all content
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const resize = ()=>{
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', resize);
        resize();
        class Cloud {
            constructor(){
                this.reset();
            }
            reset() {
                this.x = Math.random() * canvas.width;
                this.y = canvas.height + Math.random() * 200;
                this.size = 50 + Math.random() * 150;
                this.speed = 0.2 + Math.random() * 0.5;
                this.opacity = 0.3 + Math.random() * 0.3;
            }
            draw() {
                const gradient = ctx.createRadialGradient(this.x, this.y, this.size * 0.3, this.x, this.y, this.size);
                gradient.addColorStop(0, `rgba(255,255,255,${this.opacity})`);
                gradient.addColorStop(1, 'rgba(255,255,255,0)');
                ctx.fillStyle = gradient;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
            }
            update() {
                this.y -= this.speed;
                if (this.y + this.size < 0) this.reset();
                this.draw();
            }
        }
        const clouds = Array.from({
            length: 30
        }, ()=>new Cloud());
        console.log('Rising clouds initialized with', clouds.length, 'clouds');
        let animationId;
        const animate = ()=>{
            ctx.fillStyle = '#D9D1E5'; // light purple background
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            clouds.forEach((c)=>c.update());
            animationId = requestAnimationFrame(animate);
        };
        animate();
        console.log('Rising clouds animation started');
        return ()=>{
            cancelAnimationFrame(animationId);
            window.removeEventListener('resize', resize);
            canvas.remove();
        };
    }, [
        shouldBeActive
    ]);
    return canvasRef;
};



var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
var $75fd433d139ab920$export$463b44d9bf3628be;
$75fd433d139ab920$export$463b44d9bf3628be = `xbR_SG_img`;


var $897ca70e3917db7a$exports = {};
$897ca70e3917db7a$exports = $parcel$resolve("5BAP7");


const $99f792b05cf0ccb3$var$gateUrl = new URL($897ca70e3917db7a$exports).href;
const $99f792b05cf0ccb3$var$ParallaxImage = ({ speed: speed = 0.2, direction: direction = 'down' })=>{
    const ref = (0, $3aPmr.useRef)(null);
    const [isMobile, setIsMobile] = (0, $3aPmr.useState)(false);
    // check mobile on mount + resize
    (0, $3aPmr.useEffect)(()=>{
        const checkMobile = ()=>setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return ()=>window.removeEventListener('resize', checkMobile);
    }, []);
    (0, $3aPmr.useEffect)(()=>{
        const factor = direction === 'down' ? -1 : 1;
        let ticking = false;
        const handleScroll = ()=>{
            if (!ticking) {
                requestAnimationFrame(()=>{
                    if (ref.current) {
                        const offsetY = window.scrollY * speed * factor;
                        if (isMobile) // mobile: centered
                        ref.current.style.transform = `translate(-50%, -50%) translateY(${offsetY}px)`;
                        else // desktop: fixed to right, vertically centered
                        ref.current.style.transform = `translateY(-50%) translateY(${offsetY}px)`;
                    }
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, [
        speed,
        direction,
        isMobile
    ]);
    return /*#__PURE__*/ (0, $7Do5B.h)("img", {
        ref: ref,
        src: $99f792b05cf0ccb3$var$gateUrl,
        alt: "Parallax Background",
        className: $75fd433d139ab920$export$463b44d9bf3628be,
        style: {
            position: 'fixed',
            top: '50%',
            width: isMobile ? '80%' : '500px',
            pointerEvents: 'none',
            willChange: 'transform',
            zIndex: 0,
            ...isMobile ? {
                left: '50%'
            } : {
                right: 0
            },
            transform: isMobile ? 'translate(-50%, -50%)' : 'translateY(-50%)'
        }
    });
};
var $99f792b05cf0ccb3$export$2e2bcd8739ae039 = $99f792b05cf0ccb3$var$ParallaxImage;


// test out the regular i18n for preact also try out JSON again!
const $d0bb92445f8cf837$var$showFooterHeader = false;


// add a switch to DE
const $d0bb92445f8cf837$var$App = ()=>{
    const [definition, setDefinition] = (0, $3aPmr.useState)((0, (/*@__PURE__*/$parcel$interopDefault($dcjvn))));
    const currentPath = (0, $5648240c50356196$export$2e2bcd8739ae039)();
    const locale = (0, $jZHGC.default)();
    const routes = (0, $9tqvu.getRoutesByLocale)(locale);
    // Check if current path matches home route
    const isHomePage = currentPath === routes.HOME;
    // Only show rising clouds on non-home pages
    (0, $978db4e278a019b6$export$cf4c059935abd024)(!isHomePage);
    (0, $3aPmr.useEffect)(()=>{
        const sub = PubSub.subscribe("LANGUAGE", mySubscriber);
        return ()=>PubSub.unsubscribe(sub);
    }, []);
    const mySubscriber = (msg, data)=>{
        if (data === "de") (parcelRequire("6WvJn")).then((definition)=>setDefinition(definition));
        else Promise.resolve((parcelRequire("dcjvn"))).then((definition)=>setDefinition(definition));
    };
    return /*#__PURE__*/ (0, $7Do5B.h)((0, $a8aa41921077fdaf$export$480518999dfc4151), {
        dictionary: definition
    }, !isHomePage && /*#__PURE__*/ (0, $7Do5B.h)((0, $ef52437885d17bc2$export$2e2bcd8739ae039), null), !isHomePage && /*#__PURE__*/ (0, $7Do5B.h)((0, $99f792b05cf0ccb3$export$2e2bcd8739ae039), {
        speed: 0.015
    }), /*#__PURE__*/ (0, $7Do5B.h)((0, $ab7ed3762a5ae72a$export$2e2bcd8739ae039), null), $d0bb92445f8cf837$var$showFooterHeader && /*#__PURE__*/ (0, $7Do5B.h)((0, $efe4c661c5a2a935$export$2e2bcd8739ae039), null));
};
(0, $7Do5B.render)(/*#__PURE__*/ (0, $7Do5B.h)($d0bb92445f8cf837$var$App, null), document.getElementById("root"));


//# sourceMappingURL=r_k.1ff3bf52.js.map
